import { useEffect, useRef, useState } from 'react';

const tabs = [
  { name: '내 설문', value: 'my' },
  { name: '참여 설문', value: 'participated' },
];

interface MyQuestionFilterProps {
  handleParamChange: (isMy: string) => void;
}

const MyQuestionFilter = ({handleParamChange}: MyQuestionFilterProps) => {
  const [activeTab, setActiveTab] = useState(tabs[0].value);
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const [underlineStyle, setUnderlineStyle] = useState({});
  useEffect(() => {
    const activeIndex = tabs.findIndex(tab => tab.value === activeTab);
    const currentTab = tabRefs.current[activeIndex];
    handleParamChange(activeTab);
    if (currentTab) {
      setUnderlineStyle({
        left: currentTab.offsetLeft,
        width: currentTab.offsetWidth,
      });
    }
  }, [activeTab, handleParamChange]);
  return (
    <div className="relative border-b border-gray-200">
      <div className="flex items-center">
        {tabs.map((tab, index) => (
          <button key={tab.value} ref={el => {
            tabRefs.current[index] = el;
          }} onClick={() => setActiveTab(tab.value)}
                  className={`px-4 py-3 text-sm font-semibold leading-5 transition-colors duration-200 ease-in-out focus:outline-none ${activeTab === tab.value ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'}`}>{tab.name}</button>
        ))}
      </div>
      <div className="absolute bottom-[-1px] h-0.5 bg-gray-800 transition-all duration-300 ease-in-out"
           style={underlineStyle} />
    </div>
  );
};
export default MyQuestionFilter;
